import { PlantillaTurnoFormModel } from './PlantillaTurnoFormModel';

const {
    formField: {
        name,
        startTime,
        endTime,
        durationHours,
        position
    }
} = PlantillaTurnoFormModel;

export const formInitialValues = {
    [name.name]: '',
    [position.name]: '',
    [startTime.name]: '',
    [endTime.name]: '',
    [durationHours.name]: '',
};
